import { render, staticRenderFns } from "./dedicatedDietListFood.vue?vue&type=template&id=9035bb60"
import script from "./dedicatedDietListFood.vue?vue&type=script&lang=js"
export * from "./dedicatedDietListFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports